import { useState, useEffect } from 'react';
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Modal } from '@mantine/core';
import { api } from './apiClient';
import Login from './components/Login';
import MobileHomeScreen from './components/mobile/MobileHomeScreen';
import MobileExamView from './components/mobile/MobileExamView';
import MobileSettingsScreen from './components/mobile/MobileSettingsScreen';
import MobileCertListScreen from './components/mobile/MobileCertListScreen';

function MobileApp() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [certificationCodes, setCertificationCodes] = useState([]);

  useEffect(() => {
    getCurrentUser()
      .then((cognitoUser) => {
        setUser(cognitoUser);
        setIsModalOpen(false);
      })
      .catch(() => {
        setUser(null);
        setIsModalOpen(true);
      });

    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn') {
        getCurrentUser().then((cognitoUser) => {
          setUser(cognitoUser);
          setIsModalOpen(false);
        });
      } else if (payload.event === 'signedOut') {
        setUser(null);
        setIsModalOpen(true);
        navigate('/Study', { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (!user) return;
    api.get('/certifications', { field: 'code' })
      .then((data) => {
        const codes = Array.from(new Set((data || []).map((r) => r?.code).filter(Boolean)));
        setCertificationCodes(codes);
      })
      .catch(() => {});
  }, [user]);

  const handleLogout = () => signOut();

  const loginModal = (
    <Modal
      opened={isModalOpen}
      onClose={() => {}}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      size="lg"
    >
      <Login onLogin={() => {}} />
    </Modal>
  );

  return (
    <div style={{
      backgroundColor: 'var(--mantine-color-body)',
      minHeight: '100vh',
      width: '100%',
    }}>
      <Routes>
        <Route path="/" element={<Navigate to="/Study" replace />} />
        <Route
          path="/Study"
          element={
            !user ? loginModal : (
              <MobileHomeScreen user={user} onLogout={handleLogout} />
            )
          }
        />
        {certificationCodes.map((code) => (
          <Route
            key={code}
            path={`/Study/${code}`}
            element={
              !user ? loginModal : (
                <MobileExamView selectedCertification={code} user={user} onLogout={handleLogout} />
              )
            }
          />
        ))}
        <Route
          path="/Settings"
          element={
            !user ? loginModal : (
              <MobileSettingsScreen user={user} onLogout={handleLogout} />
            )
          }
        />
        <Route
          path="/Certifications"
          element={
            !user ? loginModal : (
              <MobileCertListScreen onBack={() => navigate(-1)} />
            )
          }
        />
        <Route path="*" element={<Navigate to="/Study" replace />} />
      </Routes>
    </div>
  );
}

export default MobileApp;
